import type { NextPage, GetStaticProps } from 'next';

import PageService from 'services/PageService/PageService';

import PageLayout from 'blocks/Layouts/page-layout';
import GlobalLayout from 'blocks/Layouts/GlobalLayout';
import TheTeam from 'blocks/the-team';

import { navigationPaths, PAGE_INVALIDATION_INTERVAL } from 'data/constants';

import type { StaticPageContentProps } from 'data/staticPageContent';
import StaticPageContent from 'data/staticPageContent';

import type { IGenericPage, ITheTeamPage } from 'types/interfaces';

import theTeamImage from 'assets/the-team/header-image.webp';

interface ITheTeamPageInterface extends ITheTeamPage, IGenericPage {
  pageContent: StaticPageContentProps;
}

const TheTeamPage: NextPage<ITheTeamPageInterface> = ({
  globalLayoutProps,
  pageContent,
  ourTeam: teamMembers,
}) => {
  return (
    <GlobalLayout {...globalLayoutProps}>
      <PageLayout {...pageContent} image={theTeamImage}>
        <TheTeam teamMembers={teamMembers} />
      </PageLayout>
    </GlobalLayout>
  );
};

export default TheTeamPage;

export const getStaticProps: GetStaticProps = async () => {
  const genericPageProps = await PageService.getGenericPageProps({
    navPath: navigationPaths.THE_TEAM,
  });
  const theTeamPageProps = await PageService.getTheTeamPageProps();
  const pageContent = StaticPageContent[navigationPaths.THE_TEAM];

  return {
    props: {
      ...genericPageProps,
      ...theTeamPageProps,
      pageContent,
    },
    revalidate: PAGE_INVALIDATION_INTERVAL,
  };
};
